import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    const res = await login(email, password);
    setSubmitting(false);
    if (res.ok) {
      toast.success("Welcome back.");
      navigate("/admin");
    } else {
      setError(res.error);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-bone" data-testid="admin-login-page">
      <div className="p-6">
        <Link to="/" className="font-serif text-xl text-forest" data-testid="admin-login-home-link">Shelton Law</Link>
      </div>
      <div className="flex-1 flex items-center justify-center px-6 py-12">
        <div className="w-full max-w-md">
          <p className="overline mb-3">Firm Administration</p>
          <h1 className="font-serif text-4xl text-forest leading-tight mb-2">Sign in</h1>
          <p className="text-ink-soft text-sm mb-8">Manage blog posts and firm content.</p>

          <form onSubmit={onSubmit} className="space-y-5">
            <div>
              <Label htmlFor="email" className="text-ink">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="mt-2 bg-bone border-line"
                data-testid="admin-login-email"
              />
            </div>
            <div>
              <Label htmlFor="password" className="text-ink">Password</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="mt-2 bg-bone border-line"
                data-testid="admin-login-password"
              />
            </div>
            {error && (
              <p className="text-destructive text-sm" data-testid="admin-login-error">{error}</p>
            )}
            <Button
              type="submit"
              disabled={submitting}
              className="w-full bg-forest text-bone hover:bg-forest-light rounded-none py-6"
              data-testid="admin-login-submit"
            >
              {submitting ? "Signing in…" : "Sign in"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
